/* eslint-disable no-mixed-spaces-and-tabs */
import AcIcon from 'ac-components/ac-icon';
import Tab from 'ac-components/ac-tab';
import classnames from 'classnames';
import useResizeObserver from 'hooks/use-resize-observer';
import { useTranslation } from 'hooks/use-translation';
import { useModalContext } from 'hooks/useModalContext';
import React, { FC, useEffect, useMemo, useRef, useState } from 'react';
import styles from './styles.scss';

/**  处理数据 */
function splitList(list: any[], num: number) {
	const copyList = [...list];
	copyList.splice(num, copyList.length - 1);
	return copyList;
}
const expandObj: any = {};

const ClassesSection: FC = () => {
	const { width } = useResizeObserver();
	const { t, local, list, transData } = useTranslation('home.classes');
	const { setTrigger, isShow, setHeader, setClassName, extraObject, setExtraObject } = useModalContext();
	const [showAll, setShowAll] = useState<boolean>(extraObject?.listAll?.length > 10);
	const classesRef = useRef<any>(null);
	const headerRef = useRef<any>(null);
	const tabRef = useRef<any>(null);
	const [isExpand, setExpand] = useState<boolean>(false);
	const [item, setItem] = useState<any>();
	const [tabHeight, setTabHeight] = useState<any>();

	const renderItemIcon = useMemo(() => {
		return extraObject?.listAll?.map((item: { title: any; img: any }, index: React.Key | undefined) => {
			const { title, img } = item;
			return (
				<div
					className={styles['item-icon']}
					key={index}
					onClick={() => {
						setItem(item);
						setClassName(styles['ac-classes-modal']);
						setTrigger(true);
					}}>
					<h3>{title}</h3>
					<img src={img} alt="" loading="lazy" />
				</div>
			);
		});
	}, [extraObject?.listAll]);

	const renderButton = useMemo(() => {
		return (
			<div
				className={styles['button-wrap']}
				onClick={() => {
					if (showAll) {
						classesRef.current.scrollIntoView(true);
					}
					setShowAll(!showAll);
				}}>
				<h2>{transData.buttons[`${showAll}`]}</h2>
			</div>
		);
	}, [transData, showAll]);

	// input 获取焦点时，设置 header
	const onFocus = () => {
		const firstInput = document.querySelector('.ac-modal-form input');
		const headerIcon = headerRef.current.children[0].children[0];
		if (firstInput) {
			firstInput.addEventListener('focus', (e) => {
				headerIcon.style.height = '50px';
				headerIcon.style.width = '40px';
				tabRef.current.tabList.style.height = 0;
				setTimeout(() => {
					setExpand(true);
				}, 300);
			});
		}
	};
	const setIsExpand = () => {
		// eslint-disable-next-line no-unused-expressions
		expandObj?.setExpand?.(true);
		delete expandObj.setExpand;
	};
	const onScroll = () => {
		const adModal = document.querySelector('.ac-modal-form');
		setIsExpand();
		if (!tabHeight) {
			setTabHeight(tabRef.current.tabList.offsetHeight);
		}
		if (adModal) {
			const headerIcon = headerRef.current.children[0].children[0];
			const handleScroll = () => {
				const height = headerIcon.clientHeight - adModal.scrollTop;
				if (width < 768) {
					if (adModal.scrollTop > 10) {
						headerIcon.style.height = '50px';
						headerIcon.style.width = '40px';
						adModal.removeEventListener('scroll', handleScroll);
						tabRef.current.tabList.style.height = 0;
						setTimeout(() => {
							setExpand(true);
						}, 300);
					} else {
						headerIcon.style.height = `${height}px`;
						tabRef.current.tabList.style.height = tabRef.current.tabList.offsetHeight - adModal.scrollTop + 'px';

						headerIcon.children[0].style.top = headerIcon.children[0].style.top == 9 ? 9 : headerIcon.children[0].style.top--;
					}
				} else {
					if (adModal.scrollTop > 10) {
						headerIcon.style.height = '80px';
						headerIcon.style.width = '64px';
						adModal.removeEventListener('scroll', handleScroll);
						tabRef.current.tabList.style.height = 0;

						setTimeout(() => {
							setExpand(true);
						}, 300);
					} else {
						tabRef.current.tabList.style.height = tabRef.current.tabList.offsetHeight - adModal.scrollTop + 'px';
						headerIcon.style.width = `${headerIcon.clientWidth - adModal.scrollTop}px`;
						headerIcon.style.height = `${height}px`;
					}
				}
			};

			if (!isExpand) {
				adModal.addEventListener('scroll', handleScroll);
			} else {
				adModal.removeEventListener('scroll', handleScroll);
			}
		}

		if (width < 768) {
			onFocus();
		}
	};

	const handleClick = (e) => {
		e.target.parentElement.style.display = 'none';
		const adModal = document.querySelector('.ac-modal-form');
		const headerIcon = headerRef.current.children[0].children[0];

		if (adModal) {
			adModal.scrollTop = 0;
		}
		tabRef.current.tabList.style.height = tabHeight + 'px';
		if (width < 768) {
			headerIcon.style.height = '80px';
			headerIcon.style.width = '60px';
		} else {
			headerIcon.style.height = '160px';
			headerIcon.style.width = '128px';
		}
		setTimeout(() => {
			setExpand(false);
		}, 300);
	};

	// 弹窗header模板
	const RenderItemHeader = (props: any) => {
		const { item, isExpand, onClick } = props;
		if (!item) return null;
		const { title, img, tabs } = item;
		return width >= 768 ? (
			<div className={classnames(styles['header-content'], { [`${styles.isExpand}`]: isExpand })} ref={headerRef}>
				<div className={styles['header-content-left']}>
					<div className={styles['item-icon']}>
						<h3>{title}</h3>
						<img src={img} alt="" loading="lazy" />
					</div>
				</div>
				<div className={styles['header-content-right']}>
					<h2>{t('home.classes.titleSuffix', { prefix: title })}</h2>
					{isExpand && (
						<div className={styles['view-more']} onClick={onClick}>
							<span>{transData.viewMore}</span>
							<AcIcon icon="icon_arrowdown" size={16} />
						</div>
					)}
					<Tab tabs={tabs} ref={tabRef}>
						{tabs.map((item: any, index: string | number | undefined) => {
							return (
								<ul key={index} className={styles['tab-content']}>
									{item.context.map((desc: string, index: string | number | undefined) => {
										return (
											<li key={index}>
												<span>{desc}</span>
											</li>
										);
									})}
								</ul>
							);
						})}
					</Tab>
				</div>
			</div>
		) : (
			// 手机端
			<div className={classnames(styles['header-content'], { [`${styles.isExpand}`]: isExpand })} ref={headerRef}>
				<div className={styles['header-content-left']}>
					<div className={styles['item-icon']}>
						<h3>{title}</h3>
						<img src={img} alt="" loading="lazy" />
					</div>
					<div className={styles['header-content-left-right']}>
						<h2>{t('home.classes.titleSuffix', { prefix: title })}</h2>
						{isExpand && (
							<div className={styles['view-more']} onClick={onClick}>
								<span>{transData.viewMore}</span>
								<AcIcon icon="icon_arrowdown" size={12} />
							</div>
						)}
					</div>
				</div>
				<div className={styles['header-content-right']}>
					<Tab tabs={tabs} ref={tabRef}>
						{tabs.map((item: any, index: string | number | undefined) => {
							return (
								<ul key={index} className={styles['tab-content']}>
									{item.context.map((desc: string, index: string | number | undefined) => {
										return (
											<li key={index}>
												<span>{desc}</span>
											</li>
										);
									})}
								</ul>
							);
						})}
					</Tab>
				</div>
			</div>
		);
	};

	// 渲染弹窗header模块
	useEffect(() => {
		if (item) {
			setHeader(() => <RenderItemHeader item={item} isExpand={isExpand} onClick={handleClick} />);
		}
	}, [item, isExpand]);

	// 设置弹窗数据
	useEffect(() => {
		if (showAll) {
			if (extraObject?.listAll?.length == list) return;
			setExtraObject({
				listAll: list,
			});
		} else {
			setExtraObject({
				listAll: width >= 768 && width < 1192 ? splitList(list, 8) : splitList(list, 10),
			});
		}
	}, [showAll, list, width]);

	useEffect(() => {
		if (!isShow && width < 768) {
			expandObj.setExpand = setExpand;
		}
	}, [isShow, width]);

	// init
	useEffect(() => {
		if (isShow) {
			setTimeout(() => {
				onScroll();
			});
		} else {
			setHeader(null);
			setItem(null);
			setExpand(false);
		}
	}, [isShow, isExpand]);

	return (
		<section className={classnames(styles['ac-classes'], styles[`ac-classes-${local}`])} ref={classesRef}>
			<div className={styles['ac-classes-container']}>
				<h1>
					{transData.title.h1}
					<span>{transData.title.span}</span>
				</h1>
				<div className={styles['ac-classes-list']}>{renderItemIcon}</div>
				{renderButton}
			</div>
		</section>
	);
};

export default ClassesSection;
